module.exports = __webpack_public_path__ + "img/42.6511f7b5.jpg";